import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react'; // ✅ ADD THIS IMPORT
import './App.css';
import Navbar from './components/Navbar';
import { CartProvider  } from './context/CartContext';
import GSAPExpandGallery from './components/GSAPExpandGallery';
//import ValentinesBanner from './components/ValentinesDayBanner';
import MothersDayBanner from './components/MothersDayBanner';
import ProductSection from './components/ProductSection';
import ReviewsSection from './components/ReviewSection';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Checkout from './pages/Checkout';
import AdminDashboard from './pages/AdminDashBoard';
import AdminAddProduct from './pages/AdminAddProduct';
import BooBouquetBanner from './components/BooBouqetBanner';
import TermsAndConditions from './pages/TermsAndConditions';
import ScrollToTop from './components/ScrollToTop';
//import VdayProducts from './components/VdayProducts';
//import SubscriptionFlowers from './pages/SubscriptionFlowers';
//import SubscriptionPreviewSection from './components/SubscriptionPreview';
//import SubscriptionCheckout from './pages/SubscriptionCheckout';
import AdminLogin from './pages/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import MothersDaySection from './components/MothersDayProducts';


// Create a Home component that handles scrolling
const Home = () => {
  const location = useLocation();

//   useEffect(() => {
//   if (location.state?.scrollToProducts) {
//     setTimeout(() => {
//       const valentineBanner = document.querySelector('.valentines-banner');
//       if (valentineBanner) {
//         valentineBanner.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       }
//     }, 100);
//   }
// }, [location]);

  return (
    <div className="bg-pink-50">
      <GSAPExpandGallery />
      
      {/* <MothersDayBanner /> */}
      {/* Valentine's Day Banner - NEW! */}
      {/*<ValentinesBanner /> */}
      
      {/* <VdayProducts /> */}


      {/* <MothersDaySection /> */}
      
      
      <div className="w-full bg-pink-50 py-16">
        <div className="max-w-8xl mx-auto px-4">
          <div className="flex items-center justify-center gap-4">
    
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-rose-300 to-rose-400"></div>
            
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-rose-400 animate-pulse"></div>
              <svg className="w-6 h-6 text-rose-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
              </svg>
              <div className="w-2 h-2 rounded-full bg-rose-400 animate-pulse"></div>
            </div>
            

            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-rose-300 to-rose-400"></div>
          </div>
        </div>
      </div>
        
      
      {/* Product Section with ID */}
      <div id="our-collection" className="pt-12">
        <ProductSection />
      </div>
      
  
    {/* Aesthetic Divider Bar */}
      <div className="w-full bg-pink-50 py-12 md:py-24">
        <div className="max-w-8xl mx-auto px-4">
          <div className="flex items-center justify-center gap-4">
            {/* Left line */}
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-rose-300 to-rose-400"></div>
            
            {/* Center ornament */}
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-rose-400 animate-pulse"></div>
              <svg className="w-6 h-6 text-rose-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
              </svg>
              <div className="w-2 h-2 rounded-full bg-rose-400 animate-pulse"></div>
            </div>
            
            {/* Right line */}
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-rose-300 to-rose-400"></div>
          </div>
        </div>
      </div>

      {/* Subscription Preview Section - NEW! */}
      {/* <SubscriptionPreviewSection /> */}

      <ReviewsSection />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <div>
          <Navbar />
          <Routes>
            {/* Home page */}
            <Route path="/" element={<Home />} />
          
            {/* Product detail page */}
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            {/* <Route path="/subscription" element={<SubscriptionFlowers />} /> */}
            {/* <Route path="/subscription-checkout" element={<SubscriptionCheckout />} /> */}
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLogin />} />
            {/* Protected Admin Route */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />

        <Route path="/admin/add-product" element={
  <ProtectedRoute>
    <AdminAddProduct />
  </ProtectedRoute>
} />

          </Routes>
          <Footer />
          <Analytics />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;